const C = require("../constants");

const listIngredientsStock = ingredients_stock => {
    return {
        type: C.INGREDIENTS_STOCK,
        ingredients_stock
    }
};

const updateIngredientStock = ingredient_stock => {
    return {
        type: C.INGREDIENTS_STOCK_UPDATE,
        ingredient_stock
    }
};

export {
    listIngredientsStock,
    updateIngredientStock
};


// WEBPACK FOOTER //
// ./src/actions/IngredientStockActions.js